
import UserLayout from '../../layouts/UserLayout'
import Kyc from '../../components/Kyc'

const UserKyc = () => {
  return (
    <UserLayout>
    <Kyc />
    </UserLayout>
  )
}

export default UserKyc
